import React, { useState, useContext, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { useHistory } from "react-router-dom";
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

import StudentContext from '../../../context/student-context';
import { submitSelectedCluster } from '../../../actions/home-actions'
import { changeStudentConsent } from '../../../actions/home-actions'
import TermsAndConditionsModal from './TermsAndConditionsModal'

import {setStudentSelectClusterSession, setStudentConsentSession, getStudentNumberFromSession } from '../../../utils/helpers/others/SessionHelper';

const ClusterModal2 = ({ selectCluster, studentConsent }) => {
    const history = useHistory();
    const { dispatchStudent } = useContext(StudentContext);
    const [isOpen, setIsOpen] = useState(selectCluster === "true" ? false : true)
    const [showTandCModal, setShowTandCModal] = useState(selectCluster === "false" ||studentConsent === 'true' ? false : true);
    const [cluster, setCluster] = React.useState('HSS');

    const handleChange = (event) => setCluster(event.target.value);

    const handleOk = async () => {
        let response = await submitSelectedCluster(getStudentNumberFromSession(), cluster);
        if (response > 200 || response.status === "Failed") {
            return history.push("/SessionTimeOut")
        }

        setIsOpen(false);
        setShowTandCModal(true);
        setStudentSelectClusterSession(true);

        dispatchStudent({ type: 'SET_DINOSAUR', dinosaur: { cluster: cluster, level: 0 } });
    }
    const handleAgree = async () => {
        let response = await changeStudentConsent(getStudentNumberFromSession());
        if (response > 200 || response.status === "Failed") {
            return history.push("/SessionTimeOut")
        }
        setStudentConsentSession(true);
        setShowTandCModal(false);
        dispatchStudent({type : 'SET_STUDENT_CONSENT', studentConsent : true});
        
    }

    return (
        <div>
            {
                showTandCModal ?
                    <TermsAndConditionsModal studentConsent={studentConsent} handleAgree = {handleAgree} /> :
                    <></>
            }

            <Dialog fullWidth={true}
                maxWidth={'md'}
                open={isOpen}>
                <DialogContent>
                    <div className="completedsurvey__root" width="400px">
                        <Paper className="completedsurvey_headingHolder">
                            <CardHeader title={<span className="adventurelearn__header">Please select which cluster you belong.</span>} />
                        </Paper>
                        <CardContent>
                            <Grid
                                container
                                direction="column"
                                justify="center"
                                alignItems="center">
                                <Grid
                                    container
                                    direction="column"
                                    justify="space-around"
                                    alignItems="center">

                                    <FormControl component="fieldset">
                                        <FormLabel component="legend">Academic Cluster</FormLabel>
                                        <RadioGroup aria-label="cluster" name="cluster" value={cluster} onChange={handleChange}>
                                            <FormControlLabel value="HSS" control={<Radio />} label="Health and Social Science" />
                                            <FormControlLabel value="CEFT" control={<Radio />} label="Chemical Engineering and Food Technology" />
                                            <FormControlLabel value="ICT" control={<Radio />} label="Infocomm Technology" />
                                            <FormControlLabel value="ENG" control={<Radio />} label="Engineering" />
                                            <FormControlLabel value="DSB" control={<Radio />} label="Designed and Specialized Business" />
                                        </RadioGroup>
                                    </FormControl>

                                </Grid>

                                <Grid
                                    container
                                    direction="row"
                                    justify="space-evenly"
                                    alignItems="flex-start">
                                    <Button variant={'outlined'} onClick={() => handleOk()} className="adventurelearn__dialogOk">
                                        Ok
                                    </Button>
                                </Grid>

                            </Grid>
                        </CardContent>
                    </div>
                </DialogContent>
            </Dialog>
        </div >
    );
}

export { ClusterModal2 as default }